import config from 'config'
import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector, useDispatch } from 'react-redux'
import dayjs from 'dayjs'
import styles from './styles.module.scss'
import Badge from 'srcReact/components/common2/Badge'
import { getFlaggedColor } from 'srcReact/helpers/utils'
import Button from 'srcReact/components/common2/Button'
import { getDateFormat3, getTimeFormat1 } from 'srcReact/helpers/datetimeHelper'
import { redirectToPage } from 'srcReact/helpers/history'
import Icon from 'srcReact/components/icons/Icon'
import LightProfileProto from 'srcReact/components/common2/LightProfileModal/LightProfilPrototype'
import { lightProfileActions } from 'srcReact/components/common2/LightProfileModal/actions'
import { moderationReportActions } from 'srcReact/ModerationReportPage'
import { getCurrentOrgId } from 'srcReact/helpers/organizationHelper'
import SuspendModal from '../SuspendModal'
import MembersModal from '../MembersModal'
import { checkNested } from 'srcReact/helpers/validator'
import MediaImage from 'srcReact/components/common2/MediaImage'
import FileNavigationPopup from 'srcReact/components/common2/FileNavigationPopup'
import DocumentPreview from 'srcReact/MessengerPage/components/DocumentPreview'
import { isFileImage } from 'srcReact/helpers/fileHelper'

const MainContent = ({ type, postId, post }) => {
  const { t } = useTranslation()

  const dispatch = useDispatch()
  const {
    login: { user: loggedInUser },
    common: { isNative },
    moderationReport: { reinstate, validateSuccess, loading }
  } = useSelector((state) => state)
  const [isOpen, setIsOpen] = useState(false)
  const [isSuspendModalOpen, setIsSuspendModalOpen] = useState(false)
  const [isMembersModalOpen, setIsMembersModalOpen] = useState(false)
  const [isFileModalOpen, setIsFileModalOpen] = useState(false)
  const [currentFile, setCurrenFile] = useState(null)
  const [currentFileIndex, setCurrenFileIndex] = useState(-1)
  const [files, setFiles] = useState([])

  useEffect(() => {
    if (checkNested(reinstate, 'data', 'action', 'reinstate_request') && reinstate.data.action.reinstate_request) {
      setIsOpen(false)
    }
  }, [reinstate && reinstate.data])
  useEffect(() => {
    if (!loading && validateSuccess) {
      setIsOpen(false)
    }
  }, [loading, validateSuccess])

  const flagInfo = post.flags && post.flags.length >= 1 && post.flags[0]

  const handlePostClick = () => {
    if (post.object_type === 'recurring_mixr') {
      const mixrId = post.moderation_action === 'suspended_awaiting_review' ? post.object_id : post.firstChild_id
      redirectToPage(`/0/home/event/${mixrId}`, isNative, true)
      return
    }
    if (post.object_type === 'mixr') {
      redirectToPage(`/0/home/event/${post.object_id}`, isNative, true)
      return
    }
    redirectToPage(`/0/home/group/${post.object_id}`, isNative, true)
  }
  const handleMemberClick = (userId, screen) => {
    const lp = new LightProfileProto()
    lp.userId = userId
    lp.screen = screen
    dispatch(lightProfileActions.openLightProfileModal(lp))
  }
  const handleFlagAction = (action) => {
    if (post.id_flagged_post && post.object_type && post.object_id && action) {
      dispatch(moderationReportActions.flagAction(post.id_flagged_post, post.object_type, post.object_id, action))
    }
  }
  const handleValidate = () => {
    const orgId = getCurrentOrgId()
    dispatch(moderationReportActions.validate(post.moderation_id, orgId, post.object_id))
  }

  const hideSuspendModal = () => {
    setIsSuspendModalOpen(false)
  }

  const hideMembersModal = () => {
    setIsMembersModalOpen(false)
  }

  const handleSuspend = (message) => {
    const orgId = getCurrentOrgId()
    dispatch(moderationReportActions.suspend(post.moderation_id, orgId, message, post.object_id))
  }

  const openImageModal = (file, index, files) => {
    setIsFileModalOpen(true)
    setCurrenFile(file)
    setCurrenFileIndex(index)
    setFiles(files)
  }

  const closeImageModal = () => {
    setIsFileModalOpen(false)
    setCurrenFile(null)
    setCurrenFileIndex(-1)
    setFiles([])
  }

  const renderConent = () => {
    return (
      <div
        id='accordion-content'
        className={styles.mainContentAccordionContent}
        aria-labelledby='accordion-div'
        hidden={!isOpen}
        role='content'>
        <Button
          text={t('moderationReport.flagPost.contactOrganizer', {
            object_type: post.object_type === 'recurring_mixr' ? t('global.mixr') : t(`global.${post.object_type}`)
          })}
          iconPosition='start'
          customStyle={styles.contactCustomStyle}
          icon={<Icon name='write' size='large24' />}
          icon2={<Icon name='arrow-right' size='large24' />}
          handleClick={() => handleMemberClick(post.organizer_id, 'messenger')}
        />
        <ul>
          <li>
            <b>{t('moderationReport.flagPost.contentType')}:</b> {t(`global.${post.object_type}`)}
          </li>
          {type === 'awaiting_review' && post.moderation_action !== 'suspended_awaiting_review' && (
            <li>
              <b>{t('moderationReport.flagPost.reasonForFlag')}:</b> {flagInfo && flagInfo.flag_reason}
            </li>
          )}
          <li>
            <b>{t('moderationReport.flagPost.additionalJustification')}:</b>{' '}
            {flagInfo?.additional_justification || post?.suspension_message || t(`moderationReport.flagPost.none`)}
          </li>
          <li>
            <b>{t('moderationReport.flagPost.contentAuthor')}:</b>{' '}
            <span
              className={styles.highlighted}
              onClick={() =>
                handleMemberClick(type === 'workplace_activity' ? post.organizer_id : post.author_id, 'main')
              }>
              {type === 'workplace_activity' ? post.organizer_name : post.author_name}
            </span>
          </li>
          <li>
            <b>{t('moderationReport.flagPost.dateTimePosting')}: </b>
            {dayjs(post.post_date || post.created_at).format(getDateFormat3())}
            {', '} {dayjs(post.post_date || post.created_at).format(getTimeFormat1())}
          </li>
          <li>
            <b>{t('moderationReport.flagPost.textContent')}:</b>{' '}
            <div dangerouslySetInnerHTML={{ __html: post.post_content || post.message }} />
          </li>
          {post.files && post.files.length >= 1 && post.files[0].path && (
            <li>
              <br />
              <b>{t('moderationReport.flagPost.attachedMedia', { photo_count: post.files.length })}:</b>
              <div className={styles.files}>
                {post.files.map((file, index) => {
                  if (file.path) {
                    if (isFileImage(file)) {
                      return (
                        <MediaImage
                          key={index}
                          className={styles.photo}
                          file={file}
                          files={post.files.filter((x) => isFileImage(x))}
                          index={index}
                          showImageModal={openImageModal}
                        />
                      )
                    } else {
                      const fileName = file.name
                      const extension = fileName && fileName.split('.').pop().toLowerCase()
                      return (
                        <DocumentPreview
                          key={index}
                          showDownload={true}
                          showDelete={false}
                          fileName={fileName}
                          extension={extension}
                          path={file.url}
                          isNative={isNative}
                          mimeType={file.mime_type}
                          isOriginal={file.is_original}
                          originalTag={file.original_tag}
                          documentId={file.id}
                        />
                      )
                    }
                  } else return null
                })}
              </div>
            </li>
          )}
          {type === 'workplace_activity' || post.moderation_action === 'suspended_awaiting_review' ? (
            <li>
              <br />
              <b> {t('moderationReport.flagPost.yourDecision')}:</b>
              <div className={styles.decisionButton}>
                <Button
                  handleClick={handleValidate}
                  text={t('global.validate')}
                  size='large'
                  style='primary'
                  customStyle={styles.btnCustomStyle}
                />
                <Button
                  handleClick={() => setIsSuspendModalOpen(true)}
                  text={t('moderationReport.flagPost.suspend')}
                  size='large'
                  style='tertiary'
                  customStyle={styles.btnCustomStyle}
                />
              </div>
            </li>
          ) : (
            <li>
              <br />
              <b> {t('moderationReport.flagPost.yourDecision')}:</b>
              <div className={styles.decisionButton}>
                <Button
                  text={t('moderationReport.flagPost.deleteContent')}
                  size='large'
                  style='tertiary'
                  customStyle={styles.btnCustomStyle}
                  handleClick={() => handleFlagAction('delete_post')}
                />
                <Button
                  text={t('moderationReport.flagPost.dismissFlag')}
                  size='large'
                  style='tertiary'
                  customStyle={styles.btnCustomStyle}
                  handleClick={() => handleFlagAction('dismiss_flag')}
                />
              </div>
            </li>
          )}
        </ul>
      </div>
    )
  }

  if (type === 'workplace_activity') {
    return (
      <React.Fragment>
        <section className={styles.mainContentWrapper} data-postid={postId}>
          <div
            id='accordion-title'
            className={`${styles.mainContentAccordionTitle} ${isOpen && styles.isOpened}`}
            aria-expanded={isOpen}
            aria-controls='accordion-content'>
            {post.moderation_action === 'suspended_awaiting_review' ? (
              <Badge
                size='large'
                color={getFlaggedColor(post.flags_count)}
                text={t('moderationReport.suspend.suspended')}
                customCss={`${styles.iconCustomCss} ${styles.suspendBadge}`}
              />
            ) : (
              <Badge
                size='large'
                color={getFlaggedColor(post.flags_count)}
                text={t('global.new')}
                customCss={styles.iconCustomCss}
              />
            )}
            <div className={styles.title}>
              <button
                type='button'
                className={styles.highlighted}
                onClick={() => handleMemberClick(post.organizer_id, 'main')}>
                {post.organizer_name}
              </button>
              <div
                className={styles.titleText}
                dangerouslySetInnerHTML={{
                  __html:
                    post.object_type === 'group'
                      ? t('moderationReport.flagPost.newGroup', {
                          groupUrl: `/0/home/group/${post.object_id}/backNavigation`,
                          groupName: post.post_title
                        })
                      : post.object_type === 'mixr' || post.object_type === 'recurring_mixr'
                      ? t('moderationReport.flagPost.newMixr', {
                          groupUrl: `/0/home/group/${post.group_id}/backNavigation`,
                          groupName: post.group_name,
                          mixrUrl: `/0/home/event/${
                            post.object_type === 'recurring_mixr' &&
                            post.moderation_action !== 'suspended_awaiting_review'
                              ? post.firstChild_id
                              : post.object_id
                          }/backNavigation`,
                          mixrName: post.post_title
                        })
                      : ''
                }}
              />
            </div>
            <Button
              text={isOpen ? t('moderationReport.flagPost.cancelReview') : t('moderationReport.flagPost.review')}
              size='large'
              style={isOpen ? 'tertiary' : 'primary'}
              customStyle={styles.btnCustomStyle}
              handleClick={() => setIsOpen(!isOpen)}
            />
          </div>
          {renderConent()}
        </section>
        {isSuspendModalOpen && (
          <SuspendModal
            isOpen={isSuspendModalOpen}
            hideModal={hideSuspendModal}
            objectType={post.object_type === 'recurring_mixr' ? 'mixr' : post.object_type}
            objectName={post.post_title}
            onSuspend={handleSuspend}
          />
        )}
        {isFileModalOpen && currentFile && (
          <FileNavigationPopup
            isOpen={isFileModalOpen}
            file={currentFile}
            fileIndex={currentFileIndex}
            files={files}
            closeModal={closeImageModal}
            enableDeleteFile={false}
            showShareButton={false}
          />
        )}
      </React.Fragment>
    )
  } else if (type === 'awaiting_review') {
    return (
      <React.Fragment>
        <section className={styles.mainContentWrapper} data-postid={postId}>
          <div
            id='accordion-title'
            className={styles.mainContentAccordionTitle}
            aria-expanded={isOpen}
            aria-controls='accordion-content'>
            <Badge
              size='large'
              color={getFlaggedColor(post.flags_count)}
              icon='flag-icon'
              text={post.flags_count}
              customCss={styles.iconCustomCss}
            />
            {post.moderation_action === 'suspended_awaiting_review' ? (
              <div className={styles.title}>
                <div
                  role='button'
                  className={styles.highlighted}
                  onClick={() => handleMemberClick(post.organizer_id, 'main')}>
                  {post.organizer_name}
                </div>
                <div
                  dangerouslySetInnerHTML={{
                    __html: t('moderationReport.suspend.reinstateReviewTitle', {
                      object: post.object_type,
                      objectName: post.post_title,
                      url: `/0/home/${
                        post.object_type === 'mixr' || post.object_type === 'recurring_mixr'
                          ? 'event'
                          : post.object_type
                      }/${post.object_id}`
                    })
                  }}
                />
              </div>
            ) : post.flags_count > 1 ? (
              <div className={styles.title}>
                <div
                  dangerouslySetInnerHTML={{
                    __html: `${t('moderationReport.flagPost.multiple.line1')}`
                  }}
                />
                <div role='button' className={styles.highlighted} onClick={() => setIsMembersModalOpen(true)}>
                  {t('moderationReport.flagPost.multiple.usersCount', { flag_count: post.flags_count })}
                </div>
                <div
                  dangerouslySetInnerHTML={{
                    __html: t('moderationReport.flagPost.multiple.line2', {
                      first_flag_date: dayjs(post.first_flag_date).format(getDateFormat3()),
                      object_type: post.object_type
                    })
                  }}
                />
                <div role='button' className={styles.highlighted} onClick={handlePostClick}>
                  {post.post_title}
                </div>
              </div>
            ) : (
              <div className={styles.title}>
                <div dangerouslySetInnerHTML={{ __html: t('moderationReport.flagPost.single.line1') }} />
                <div
                  role='button'
                  className={styles.highlighted}
                  onClick={() => handleMemberClick(flagInfo && flagInfo.flag_id_user, 'main')}>
                  {flagInfo && flagInfo.flag_user_name}
                </div>
                <div
                  dangerouslySetInnerHTML={{
                    __html: t('moderationReport.flagPost.single.line2', {
                      flag_reason: flagInfo ? flagInfo.flag_reason : '',
                      first_flag_date: dayjs(post.first_flag_date).format(getDateFormat3()),
                      object_type: post.object_type
                    })
                  }}
                />
                <div role='button' className={styles.highlighted} onClick={handlePostClick}>
                  {post.post_title}
                </div>
              </div>
            )}
            <Button
              text={isOpen ? t('moderationReport.flagPost.cancelReview') : t('moderationReport.flagPost.review')}
              size='large'
              style={isOpen ? 'tertiary' : 'primary'}
              customStyle={styles.btnCustomStyle}
              handleClick={() => setIsOpen(!isOpen)}
            />
          </div>
          {renderConent()}
        </section>
        {isSuspendModalOpen && (
          <SuspendModal
            isOpen={isSuspendModalOpen}
            hideModal={hideSuspendModal}
            objectType={post.object_type}
            objectName={post.post_title}
            onSuspend={handleSuspend}
          />
        )}
        {isFileModalOpen && currentFile && (
          <FileNavigationPopup
            isOpen={isFileModalOpen}
            file={currentFile}
            fileIndex={currentFileIndex}
            files={files}
            closeModal={closeImageModal}
            enableDeleteFile={false}
            showShareButton={false}
          />
        )}
        {isMembersModalOpen && post.flags && post.flags.length >= 1 && (
          <MembersModal isOpen={isMembersModalOpen} hideModal={hideMembersModal} members={post.flags} />
        )}
      </React.Fragment>
    )
  } else if (type === 'history') {
    return (
      <React.Fragment>
        <section className={styles.mainContentWrapper} data-postid={postId}>
          <div
            id='accordion-title'
            className={styles.mainContentAccordionTitle}
            aria-expanded={isOpen}
            aria-controls='accordion-content'>
            <Badge
              size='large'
              color='gray'
              icon='flag-icon'
              text={post.flags_count}
              customCss={styles.iconCustomCss}
            />
            {post.flags_count > 1 ? (
              <div className={styles.title}>
                <div
                  dangerouslySetInnerHTML={{
                    __html: `${t('moderationReport.flagPost.multiple.line1')}`
                  }}
                />
                <div role='button' className={styles.highlighted} onClick={() => setIsMembersModalOpen(true)}>
                  {t('moderationReport.flagPost.multiple.usersCount', { flag_count: post.flags_count })}
                </div>
                <div
                  dangerouslySetInnerHTML={{
                    __html: t('moderationReport.flagPost.multiple.line2', {
                      first_flag_date: dayjs(post.first_flag_date).format(getDateFormat3()),
                      object_type: post.object_type
                    })
                  }}
                />
                <div role='button' className={styles.highlighted} onClick={handlePostClick}>
                  {post.post_title}
                </div>
                <div
                  dangerouslySetInnerHTML={{
                    __html: t('moderationReport.decision', {
                      action: t(`moderationReport.moderationAction.${post.moderation_action}`),
                      organizer: post.organizer_id === loggedInUser.id ? t(`global.you`) : ''
                    })
                  }}
                />
                {post.organizer_id !== loggedInUser.id && (
                  <div
                    role='button'
                    className={styles.highlighted}
                    onClick={() => handleMemberClick(post.organizer_id, 'main')}>
                    {post.organizer_name}
                  </div>
                )}
              </div>
            ) : (
              <div className={styles.title}>
                <div dangerouslySetInnerHTML={{ __html: t('moderationReport.flagPost.single.line1') }} />
                <div
                  role='button'
                  className={styles.highlighted}
                  onClick={() => handleMemberClick(flagInfo && flagInfo.flag_id_user, 'main')}>
                  {flagInfo && flagInfo.flag_user_name}
                </div>
                <div
                  dangerouslySetInnerHTML={{
                    __html: t('moderationReport.flagPost.single.line2', {
                      flag_reason: flagInfo ? flagInfo.flag_reason : '',
                      first_flag_date: dayjs(post.first_flag_date).format(getDateFormat3()),
                      object_type: post.object_type
                    })
                  }}
                />
                <div role='button' className={styles.highlighted} onClick={handlePostClick}>
                  {post.post_title}
                </div>
                <div
                  dangerouslySetInnerHTML={{
                    __html: t('moderationReport.decision', {
                      action: t(`moderationReport.moderationAction.${post.moderation_action}`),
                      organizer: post.organizer_id === loggedInUser.id ? t(`global.you`) : ''
                    })
                  }}
                />
                {post.organizer_id !== loggedInUser.id && (
                  <div
                    role='button'
                    className={styles.highlighted}
                    onClick={() => handleMemberClick(post.organizer_id, 'main')}>
                    {post.organizer_name}
                  </div>
                )}
              </div>
            )}
          </div>
        </section>
        {isMembersModalOpen && post.flags && post.flags.length >= 1 && (
          <MembersModal isOpen={isMembersModalOpen} hideModal={hideMembersModal} members={post.flags} />
        )}
        {isFileModalOpen && currentFile && (
          <FileNavigationPopup
            isOpen={isFileModalOpen}
            file={currentFile}
            fileIndex={currentFileIndex}
            files={files}
            closeModal={closeImageModal}
            enableDeleteFile={false}
            showShareButton={false}
          />
        )}
      </React.Fragment>
    )
  }
  return t('moderationReport.flagPost.none')
}

export default MainContent
